import { render } from "./RemissionsMonthlyChart.vue?vue&type=template&id=12a2f24d&scoped=true"
import script from "./RemissionsMonthlyChart.vue?vue&type=script&lang=js"
export * from "./RemissionsMonthlyChart.vue?vue&type=script&lang=js"

import "./RemissionsMonthlyChart.vue?vue&type=style&index=0&id=12a2f24d&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/RACINGBIKE/mi-stock-alavision-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a2f24d"]])

export default __exports__